import { render, staticRenderFns } from "./TheProductForm.vue?vue&type=template&id=d11383fc&scoped=true&"
import script from "./TheProductForm.vue?vue&type=script&lang=js&"
export * from "./TheProductForm.vue?vue&type=script&lang=js&"
import style0 from "./TheProductForm.vue?vue&type=style&index=0&id=d11383fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11383fc",
  null
  
)

export default component.exports